document.addEventListener('DOMContentLoaded', function () {
	const params = new URLSearchParams(window.location.search);
	const utmData = {
		utmCampaign: params.get('utm_campaign') || '',
		utmSource: params.get('utm_source') || '',
		utmMedium: params.get('utm_medium') || '',
		utmTerm: params.get('utm_term') || '',
		utmContent: params.get('utm_content') || '',
	};
	// If new UTM parameters exist, save and return them
	if (Object.values(utmData).some((value) => value !== '')) {
		sessionStorage.setItem('utmParams', JSON.stringify(utmData));
		return utmData;
	}
});
